// 仕様変更が発生した場合、ドキュメント(/docs/ecf-project-page-markup.md)も更新してください
import JQueryView, { on } from '../../../common/views/jqueryView';
import { browserName } from '../../../common/helpers/applicationHelper';
import $ from 'jquery';

export default class ShowView extends JQueryView {
  tocItems: { index: string; text: string; className: string }[] = [];
  isMobile: boolean;
  registrationModalHeight: number;
  private activeTabId: string;
  private overviewTab?: JQuery;
  private visionTab?: JQuery;

  constructor(isMobile: boolean) {
    super('#sb-site');
    this.isMobile = isMobile;
    this.registrationModalHeight = 0;
    this.activeTabId = 'overview';

    this.renderProjectTabs();
    this.renderContentBox();
    this.renderSummary();
    this.renderToc();
    this.renderProjectTabSpToc();
    this.handleToc();
    this.renderSupporter();
    this.renderTeam();
    this.renderMenter();
    this.renderReadMore();
    this.renderMileStone();

    if ($('.header-funding-amount').length > 0) {
      if ($('.header-funding-amount').css('display') != 'none') {
        $('.to-page-top-wrapper').addClass('bottom-offset');
      }
    }

    $('.header-funding-amount').css({
      position: browserName() === 'safari' ? '-webkit-sticky' : 'sticky',
      bottom: 0,
    });
    this.handleToPageTop();
    this.setRegistrationModalHeight();
    this.handleRegistrationModal();
    this.loadFacebookSdk();
  }

  @on({ event: 'click', selector: '.modal-social__btn.share' })
  onClickPopup(event: JQuery.ClickEvent) {
    event.preventDefault();
    const intWidth = '500';
    const intHeight = '400';
    const strTitle =
      typeof event.currentTarget.title !== 'undefined'
        ? event.currentTarget.title
        : 'Social Share';
    const strParam = `width= ${intWidth} ,height= ${intHeight}`;
    window.open(event.currentTarget.href, strTitle, strParam)?.focus();
  }

  @on({ event: 'click', selector: '#btn_to_page_top' })
  onClickBtnToPageTop(event: JQuery.ClickEvent) {
    event.preventDefault();
    const position = $('html').offset()?.top;
    const miriSecMove = 1000;
    if (position != null) {
      $('html, body').animate({ scrollTop: position }, miriSecMove);
    }
  }

  handleToPageTop() {
    const toPageTop = $('.to-page-top');
    toPageTop.hide();

    const thisWindow = $(window);
    $(window).scroll(() => {
      const scrollTop = thisWindow.scrollTop();
      if (scrollTop == null) {
        return;
      }

      const targetHeight = 1500;
      if (scrollTop > targetHeight) {
        toPageTop.fadeIn();
      } else {
        toPageTop.fadeOut();
      }
    });
  }

  handleToc() {
    const offsetHeight = 140;
    $('body').scrollspy({ target: '.toc', offset: offsetHeight });

    if ($('.header-funding-amount').length > 0) {
      $('#side_toc').hover(
        () => {
          $('.header-funding-amount').fadeOut(200);
        },
        () => {
          $('.header-funding-amount').fadeIn(200);
        },
      );
    }
  }

  // タブ（事業内容／代表の想いと歩み）を挿入
  renderProjectTabs() {
    const $tabsWrapper = $('#description_main').find('.tabs-wrapper');
    if ($tabsWrapper.length === 0) return;

    this.overviewTab = $tabsWrapper.find('[data-tab-id="overview"]');
    if (this.overviewTab.length === 0) return;
    this.overviewTab.attr({ id: 'tab-overview', role: 'tabpanel' });

    this.visionTab = $tabsWrapper.find('[data-tab-id="vision"]');
    if (this.visionTab.length === 0) return;
    this.visionTab.attr({ id: 'tab-vision', role: 'tabpanel' });

    let html = '<section class="project-nav">';
    html += '<div class="tab-nav-bar">';
    html += '<ul class="nav tab-nav" role="tablist" aria-label="案件詳細タブ">';
    html += '<li class="nav-item">';
    html +=
      '<a href="#tab-overview" class="nav-link active" role="tab" aria-selected="true" aria-controls="tab-overview" data-tab-target="tab-overview">事業内容</a>';
    html += '</li>';
    html += '<li class="nav-item">';
    html +=
      '<a href="#tab-vision" class="nav-link" role="tab" aria-selected="false" aria-controls="tab-vision" data-tab-target="tab-vision">代表の想いと歩み</a>';
    html += '</li>';
    html += '</ul>';
    html += '</div>';
    html +=
      '<div class="sp-current-section" role="button" tabindex="0" aria-expanded="false"></div>';
    html += '</section>';
    html += '<div class="sp-nav-spacer"></div>';
    $('#description_main').prepend(html);

    this.visionTab.hide();
  }

  renderToc() {
    const selector = '.mokuji';

    $('#detail_content')
      .find(selector)
      .each((i, item) => {
        const trimmed = item.dataset.tocTitle
          ? item.dataset.tocTitle.trim()
          : item.textContent?.trim();
        if (trimmed == null) {
          return;
        }

        if (!$(item).is(':visible')) return;

        const text = trimmed.replace('■ ', '').replace('■', '');
        if (text !== '') {
          const index = item.id || `toc-${i}`;
          const sanitizedClassName = selector
            .replace(/((:+[\w-\d]*)|[^A-z0-9-\s])/g, ' ')
            .replace(/\s{2,}/g, ' ')
            .trim();
          const subTocClassName = $(item).hasClass('mokuji-sub')
            ? 'toc-sub'
            : '';
          const className = `toc-${sanitizedClassName} ${subTocClassName}`;

          if (item.id !== index) {
            item.id = index;
          }

          this.tocItems.push({ index, text, className });
        }
      });

    if (this.tocItems.length > 0) {
      let html = '<div class="list-group" data-turbo="false">';
      const triggerOptions = [];

      this.tocItems.forEach((item, j) => {
        const options = {
          el: `.toc-li-${j}`,
          fixed: 'true',
          start: `#${item.index}`,
          position: 'top',
          positionEnd: 'top',
          className: 'toc-visible',
        };
        const addClassName = j === 0 ? 'active' : '';
        html += `\n<a href="#${item.index}" class="list-group-item list-group-item-action toc-li-${j} ${item.className} ${addClassName}">${item.text}</a>`;
        triggerOptions.push(options);
      });
      html += '</ul>';
      $('.toc').show().html(html);
    } else {
      $('.toc').hide();
    }
  }

  // タブ（事業内容／代表の想いと歩み）のスマホ用の目次を挿入
  renderProjectTabSpToc() {
    const $descriptionMain = $('#description_main');
    const $projectNav = $descriptionMain.find('.project-nav');
    if ($projectNav.length === 0) return;

    const $spCurrentSection = $projectNav.find('.sp-current-section');
    if ($spCurrentSection.length === 0) return;

    // 通常のスマホ用の目次は非表示
    $('[data-target="#model_toc"]').hide();

    $spCurrentSection.text('');
    $projectNav.toggleClass('sp-toc-empty', this.tocItems.length === 0);

    $projectNav.find('.sp-index-panel').remove();
    const $spIndexPanel = $('<div class="sp-index-panel"></div>');
    this.tocItems.forEach(item => {
      const $link = $('<a></a>').attr('href', `#${item.index}`).text(item.text);
      $spIndexPanel.append($link);
    });
    $projectNav.append($spIndexPanel);

    $projectNav.removeClass('sp-fixed sp-hidden sp-index-open');
    $descriptionMain.find('.sp-nav-spacer').removeClass('on');

    // スクロールイベント
    let ticking = false;
    let navHeight = 0;
    let navTopAbs = 0;

    // 初期のnavTopAbs（本文到達を測る自然位置）を計算
    const initialRect = $projectNav[0].getBoundingClientRect();
    const initialScrollY = window.pageYOffset;
    navTopAbs = Math.round(initialRect.top + initialScrollY);

    const update = () => {
      ticking = false;

      // スペーサーの高さをタブナビゲーションの高さに合わせる
      const navRect = $projectNav[0].getBoundingClientRect();
      if (navRect.height > 20) {
        navHeight = Math.round(navRect.height);
        $projectNav[0].style.setProperty('--sp-tabs-h', `${navHeight}px`);
        $descriptionMain.find('.sp-nav-spacer').css('height', `${navHeight}px`);
      }
      if (!navHeight) return;

      // fixed 時に content-box と左右を揃えるためのオフセット
      const bx = $descriptionMain[0].getBoundingClientRect().left;
      document.documentElement.style.setProperty(
        '--sp-nav-x',
        Math.max(0, Math.round(bx)) + 'px',
      );

      // navTopAbs は fixed 解除時のみ更新（fixed 中は top=0 になり不正になるため）
      const scrollY = window.pageYOffset;
      if (!$projectNav.hasClass('sp-fixed') && navRect.top > 0) {
        navTopAbs = Math.round(navRect.top + scrollY);
      }

      const line = navHeight + 10;
      const descriptionMainBottom =
        ($descriptionMain.offset()?.top ?? 0) +
        ($descriptionMain.outerHeight() ?? 0);
      const reached = scrollY > navTopAbs;
      const past = scrollY + navHeight + 8 >= descriptionMainBottom;

      if (!reached) {
        // スクロールがタブナビゲーションより上の場合
        // タブナビゲーション：表示
        // 目次：非表示
        $projectNav.removeClass('sp-fixed sp-hidden sp-index-open');
        $descriptionMain.find('.sp-nav-spacer').removeClass('on');
      } else if (past) {
        // スクロールが最後のコンテンツより下の場合
        // タブナビゲーション：非表示
        // 目次：非表示
        $projectNav.removeClass('sp-fixed sp-index-open');
        $projectNav.addClass('sp-hidden');
        $descriptionMain.find('.sp-nav-spacer').addClass('on');
      } else {
        // スクロールがコンテンツの内側の場合
        // タブナビゲーション：表示
        // 目次：表示
        $projectNav.addClass('sp-fixed');
        $projectNav.removeClass('sp-hidden');
        $descriptionMain.find('.sp-nav-spacer').addClass('on');

        // 現在表示されているコンテンツの目次をセット
        let currentHead: HTMLElement | null = null;
        this.tocItems.forEach(item => {
          const head = document.getElementById(item.index);
          if (head && head.getBoundingClientRect().top <= line) {
            currentHead = head;
          }
        });

        if (currentHead) {
          const text =
            $(currentHead).attr('data-toc-title') ?? $(currentHead).text();
          if ($spCurrentSection.text() !== text) {
            $spCurrentSection.text(text);
          }
        }

        // 目次一覧が開いている場合、現在のセクションに対応するリンクをハイライト
        if ($projectNav.hasClass('sp-index-open')) {
          const currentText = $spCurrentSection.text().trim();
          $spIndexPanel.find('a').each((_, link) => {
            $(link).toggleClass(
              'current',
              $(link).text().trim() === currentText,
            );
          });
        }
      }
    };

    const requestUpdate = () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    };

    $(window).off('scroll.projectTabSpToc resize.projectTabSpToc');
    $(window).on('scroll.projectTabSpToc', requestUpdate);
    $(window).on('resize.projectTabSpToc', requestUpdate);

    requestAnimationFrame(update);
  }

  setRegistrationModalHeight() {
    const modal = document.getElementById('blurred_modal');
    const element = document.getElementById('only_registered');
    if (!modal || !element) {
      return;
    }

    const position = element.getBoundingClientRect().top + window.scrollY;
    this.registrationModalHeight = position + 300;
    modal.style.top = `${position + 300}px`;
  }

  handleRegistrationModal() {
    const modal = document.getElementById('blurred_modal');
    const footer = document.getElementById('l-footer');
    const header = document.getElementById('g-header');
    if (!modal || !footer || !header) {
      return;
    }

    $(window).scroll(() => {
      const currentScroll =
        window.scrollY ||
        (document.documentElement ? document.documentElement.scrollTop : 0);
      const viewportHeight = window.innerHeight;
      const triggerPoint =
        this.registrationModalHeight -
        (viewportHeight / 2 - modal.offsetHeight / 2) +
        header.offsetHeight;

      if (
        currentScroll >= triggerPoint &&
        currentScroll < footer.offsetTop - viewportHeight
      ) {
        modal.classList.add('fixed');
        modal.style.top = `${viewportHeight / 2 - modal.offsetHeight / 2}px`;
      } else if (currentScroll >= footer.offsetTop - viewportHeight) {
        modal.classList.remove('fixed');
        modal.style.top = `${
          footer.offsetTop -
          modal.offsetHeight / 2 -
          viewportHeight / 2 -
          header.offsetHeight
        }px`;
      } else {
        modal.classList.remove('fixed');
        modal.style.top = `${this.registrationModalHeight}px`;
      }
    });
  }

  @on({ event: 'click', selector: '.toc-mokuji' })
  onClickTocMokuji(event: JQuery.ClickEvent) {
    event.preventDefault();
    $('#model_toc').modal('hide');

    const href = $(event.currentTarget).attr('href');
    if (href == null) {
      return;
    }

    const target = $(href == '#' || href === '' ? 'html' : href);
    const offset = target.offset();
    if (offset == null) {
      return;
    }

    const addOffset = this.isMobile ? 115 : 40;
    const position = offset.top - addOffset;
    const miriSecMove = 1000;
    $('html, body').animate({ scrollTop: position }, miriSecMove);
  }

  // タブ（事業内容／代表の想いと歩み）の切り替え
  @on({ event: 'click', selector: '.project-nav .nav-link[data-tab-target]' })
  onClickTabLink(event: JQuery.ClickEvent) {
    event.preventDefault();

    if (!this.overviewTab || !this.visionTab) return;

    const $link = $(event.currentTarget);
    const target = $link.attr('data-tab-target');
    if (!target) return;

    const newTabId = target.replace('tab-', '');
    if (this.activeTabId === newTabId) return;

    const $overviewLink = $(
      '.project-nav .nav-link[data-tab-target="tab-overview"]',
    );
    const $visionLink = $(
      '.project-nav .nav-link[data-tab-target="tab-vision"]',
    );
    if (newTabId === 'overview') {
      this.overviewTab.show();
      this.visionTab.hide();
      $('#description_others').show();
      $overviewLink.addClass('active').attr('aria-selected', 'true');
      $visionLink.removeClass('active').attr('aria-selected', 'false');
    } else if (newTabId === 'vision') {
      this.overviewTab.hide();
      this.visionTab.show();
      $('#description_others').hide();
      $overviewLink.removeClass('active').attr('aria-selected', 'false');
      $visionLink.addClass('active').attr('aria-selected', 'true');
    }

    this.activeTabId = newTabId;
    this.renderContentBox();
    this.renderSummary();
    this.tocItems = [];
    this.renderToc();
    this.renderProjectTabSpToc();
    this.renderMileStone();
    window.scrollTo(0, $('#description_main').offset()?.top ?? 0);
  }

  // タブ（事業内容／代表の想いと歩み）の目次一覧の表示／非表示切り替え
  @on({ event: 'click', selector: '.sp-current-section' })
  onClickSpCurrentSection(event: JQuery.ClickEvent) {
    event.stopPropagation();

    const $currentSection = $(event.currentTarget);
    const $projectNav = $('#description_main').find('.project-nav');
    const $indexPanel = $projectNav.find('.sp-index-panel');

    if (!$projectNav.hasClass('sp-index-open')) {
      const barBottom = $currentSection[0].getBoundingClientRect().bottom;
      $indexPanel.css('top', `${Math.round(barBottom)}px`);

      const currentText = $currentSection.text().trim();
      $indexPanel.find('a').each((_, link) => {
        $(link).toggleClass('current', $(link).text().trim() === currentText);
      });
    }

    $projectNav.toggleClass('sp-index-open');
    const isOpen = $projectNav.hasClass('sp-index-open');
    $currentSection.attr('aria-expanded', String(isOpen));
  }

  // タブ（事業内容／代表の想いと歩み）の目次一覧クリック時に該当セクションにスクロール
  @on({ event: 'click', selector: '.sp-index-panel a' })
  onClickSpIndexPanelLink(event: JQuery.ClickEvent) {
    event.preventDefault();
    event.stopPropagation();

    const href = $(event.currentTarget).attr('href');
    if (!href) return;

    const $target = $(href);
    if ($target.length === 0) return;

    const $projectNav = $('#description_main').find('.project-nav');
    const navHeight = $projectNav.outerHeight() ?? 0;
    const targetTop = $target.offset()?.top ?? 0;
    const scrollTo = targetTop - navHeight;

    $projectNav.removeClass('sp-index-open');
    window.scrollTo({ top: scrollTo, behavior: 'smooth' });
  }

  renderSummary() {
    $('#description_summary').html();
    $('#description_summary').html(
      '<div class="summary" data-turbo="false"></div>',
    );
    $('.summary').append(
      '<h2 class="mokuji for-summary">Summary -サマリー-</h2>',
    );
    $('#description_body')
      .find('.add-to-summary:visible')
      .each((i, item) => {
        this.renderSummaryBox(item, i + 1);
      });
  }

  renderSummaryBox(itemBox: HTMLElement, boxNumber: number) {
    const itemBlockTitles = $(itemBox).find('h2');
    let htmlTitle = '';
    if (itemBlockTitles.length > 0) {
      const textTitle = itemBlockTitles[0].textContent?.trim();
      htmlTitle = `<p class="title">${textTitle}</p>`;
    }

    $(itemBox)
      .find('h3')
      .each((i, item) => {
        const idName = `summary_${this.activeTabId}_${boxNumber}_${i + 1}`;
        $(item).attr('id', idName);
      });

    // 本文からh3を抽出してサマリー用のhtmlを作る処理
    const htmlSubTitles: string[] = [];
    $(itemBox)
      .find('h3')
      .each((i, item) => {
        const textSubTitle = item.textContent?.trim();
        const itemId = item.id;
        const htmlSubTitle =
          '<p class="sub-title">' +
          `<a class="summary-link" href="#${itemId}">` +
          `● ${textSubTitle}` +
          '</a>' +
          '</p>';
        const hideTitle = $(item).hasClass('no-use-summary');
        if (!hideTitle) {
          htmlSubTitles.push(htmlSubTitle);
        }
      });

    let html = '<div class="summary-block">';
    html += htmlTitle;
    html += htmlSubTitles.join('');
    html += '</div>';
    $('.summary').append(html);
  }

  @on({ event: 'click', selector: '.summary-link' })
  onClickSummaryLink(event: JQuery.ClickEvent) {
    event.preventDefault();
    const href = $(event.currentTarget).attr('href');
    if (href == null) {
      return;
    }

    const target = $(href == '#' || href === '' ? 'html' : href);
    const offset = target.offset();
    if (offset == null) {
      return;
    }

    const addOffset = this.isMobile ? 115 : 40;
    const position = offset.top - addOffset;
    const miriSecMove = 1000;
    $('html, body').animate({ scrollTop: position }, miriSecMove);
  }

  renderContentBox() {
    // コンテンツ枠ごとにid付与 (リンク先にするため)
    $('#description_body')
      .find('.content-box')
      .each((index, item) => {
        $(item).attr('id', `content_box_${index + 1}`);
      });

    // 見出しの自動採番をいったん全削除しないと2重表示されるバグがあるので対応した
    $('#description_body')
      .find('.header-prefix-number')
      .each((index, item) => {
        $(item).remove();
      });

    // 見出しの自動採番処理
    let visibleBlockIndex = 0;
    $('#description_body')
      .find('.add-auto-number')
      .each((indexBlock, itemBlock) => {
        const $heading = $(itemBlock).find('h2.mokuji');
        if ($heading.length > 0 && $heading.is(':visible')) {
          visibleBlockIndex++;
          $heading.prepend(
            '<span class="header-prefix-number">' +
              `${visibleBlockIndex}. ` +
              '</span>',
          );
        }
      });

    // コンテンツナビをいったん全削除しないと2重表示されるバグがあるので対応した
    $('#description_body')
      .find('.content-navi-wrapper')
      .each((index, item) => {
        $(item).remove();
      });

    // ここからコンテンツナビを生成
    const itemContentBlocks = $('#description_body').find('.add-navi:visible');
    $(itemContentBlocks).each((index, item) => {
      const htmlNavi = this.structContentNavi(index, itemContentBlocks);
      $(item).prepend(htmlNavi);
    });
  }

  structContentNavi(
    currentContentIndex: number,
    itemContentBlocks: JQuery<HTMLElement>,
  ) {
    let htmlNavi = '<div class="content-navi-wrapper">';
    htmlNavi += '<div class="content-navi">';
    htmlNavi += '<div class="content-navi-border"></div>';
    $(itemContentBlocks).each((indexBlock, itemBlock) => {
      let classBasic;
      if (indexBlock < currentContentIndex) {
        classBasic = 'content-navi-link content-navi-past';
      } else if (indexBlock === currentContentIndex) {
        classBasic =
          'content-navi-link content-navi-current content-navi-margin-right';
      } else {
        classBasic = 'content-navi-link content-navi-future';
      }

      htmlNavi +=
        `<a class="${classBasic}" href="#${itemBlock.id}">` +
        `${indexBlock + 1}` +
        '</a>';
    });
    htmlNavi += '</div>';
    htmlNavi += '</div>';

    const isLastBlock = currentContentIndex === itemContentBlocks.length - 1;
    if (isLastBlock) {
      htmlNavi = htmlNavi.replace(
        'content-navi-margin-right',
        'content-navi-margin-left',
      );
    }
    return htmlNavi;
  }

  @on({ event: 'click', selector: '.content-navi-link' })
  onClickContentNaviLink(event: JQuery.ClickEvent) {
    event.preventDefault();
    const href = $(event.currentTarget).attr('href');
    if (href == null) {
      return;
    }

    const target = $(href == '#' || href === '' ? 'html' : href);
    const offset = target.offset();
    if (offset == null) {
      return;
    }

    const addOffset = this.isMobile ? 115 : 0;
    const position = offset.top - addOffset;
    const miriSecMove = 1000;
    $('html, body').animate({ scrollTop: position }, miriSecMove);
  }

  renderSupporter() {
    $('#supporter').prop('data-turbo', false);
    $('#supporter')
      .find('.supporter-block')
      .each((i, item) => {
        const idName = `supporter_${i + 1}`;
        $(item).attr('id', idName);
        if (i === 0) {
          $(item).addClass('active');
        }
      });

    // メンバー一覧が2重に表示されるバグがあるので、一旦クリアする
    $('.supporter-prev').remove();
    $('.supporter-next').remove();
    $('.supporter-count').remove();
    $('.supporter-others-wrapper').remove();

    $('#supporter').append('<div class="supporter-prev"></div>');
    $('#supporter').append('<div class="supporter-next"></div>');
    $('#supporter').append('<div class="supporter-count"></div>');

    const htmlPersonLinks: string[] = [];
    $('#supporter')
      .find('.supporter-block')
      .each((i, item) => {
        const itemPersonName = $(item).find('.full-name');
        const textPersonName = itemPersonName[0]?.textContent?.trim() ?? '';

        const itemPersonPosition = $(item).find('.supporter-position');
        const textPersonPosition =
          itemPersonPosition[0]?.textContent?.trim() ?? '';

        const itemPersonPicture = $(item).find('.supporter-picture');
        const htmlPersonPicture = $(itemPersonPicture[0]).html();

        let htmlLink = '<a class="supporter-link" href="#supporter_header">';
        htmlLink += '<div class="link-wrapper">';
        htmlLink += `<div class="link-picture">${htmlPersonPicture}</div>`;
        htmlLink += '<div class="link-description">';
        htmlLink += `<div class="link-position">${textPersonPosition}</div>`;
        htmlLink += `<div class="link-name">${textPersonName}</div>`;
        htmlLink += '</div>';
        htmlLink += '</div>';
        htmlLink += '</a>';
        htmlPersonLinks.push(htmlLink);
      });

    let html = '<div class="supporter-others-wrapper">';
    html += '<div class="supporter-others">';
    html += htmlPersonLinks.join('');
    html += '</div>';
    html += '</div>';
    $('#supporter').append(html);

    const first_supporter_index = 0;
    this.switchSupporter(first_supporter_index);
  }

  @on({ event: 'click', selector: '.supporter-link' })
  onClickSupporterLink(event: JQuery.ClickEvent) {
    event.preventDefault();
    const href = $(event.currentTarget).attr('href');
    if (href == null) {
      return;
    }

    const target = $(href == '#' || href === '' ? 'html' : href);
    const offset = target.offset();
    if (offset == null) {
      return;
    }

    const addOffset = this.isMobile ? 40 : 0;
    const position = offset.top - addOffset;
    const miriSecMove = 500;
    $('html, body').animate({ scrollTop: position }, miriSecMove);

    const targetIndex = $(event.currentTarget).index('.supporter-link');

    setTimeout(() => {
      this.switchSupporter(targetIndex);
    }, miriSecMove);
  }

  @on({ event: 'click', selector: '.supporter-prev' })
  onClickSupporterPrev() {
    const itemBlocks = $('#supporter').find('.supporter-block');
    if (itemBlocks.length === 0) {
      return;
    }

    const itemActive = $('#supporter').find('.active');
    const currentIndex = $(itemBlocks).index($(itemActive));
    let targetIndex;
    if (currentIndex === 0) {
      targetIndex = itemBlocks.length - 1;
    } else {
      targetIndex = currentIndex - 1;
    }
    this.switchSupporter(targetIndex);
  }

  @on({ event: 'click', selector: '.supporter-next' })
  onClickSupporterNext() {
    const itemBlocks = $('#supporter').find('.supporter-block');
    if (itemBlocks.length === 0) {
      return;
    }

    const itemActive = $('#supporter').find('.active');
    const currentIndex = $(itemBlocks).index($(itemActive));
    let targetIndex;
    if (currentIndex === itemBlocks.length - 1) {
      targetIndex = 0;
    } else {
      targetIndex = currentIndex + 1;
    }
    this.switchSupporter(targetIndex);
  }

  switchSupporter(switchIndex: number) {
    const personCount = $('#supporter').find('.supporter-block').length;
    const personCountText = `${switchIndex + 1} of ${personCount}`;
    const itemPersonCount = $('#supporter').find('.supporter-count');
    $(itemPersonCount[0]).html(personCountText);

    $('#supporter')
      .find('.supporter-block')
      .each((i, item) => {
        if (i === switchIndex) {
          $(item).addClass('active').hide().fadeIn(0);
        } else {
          $(item).removeClass('active');
        }
      });

    $('#supporter')
      .find('.supporter-link')
      .each((i, item) => {
        if (i === switchIndex) {
          $(item).addClass('active');
        } else {
          $(item).removeClass('active');
        }
      });
  }

  renderTeam() {
    $('#team').prop('data-turbo', false);
    $('#team')
      .find('.member-block')
      .each((i, item) => {
        const idName = `team_member_${i + 1}`;
        $(item).attr('id', idName);
        if (i === 0) {
          $(item).addClass('active');
        }
      });

    // メンバー一覧が2重に表示されるバグがあるので、一旦クリアする
    $('.member-prev').remove();
    $('.member-next').remove();
    $('.member-count').remove();
    $('.member-others-wrapper').remove();

    $('#team').append('<div class="member-prev"></div>');
    $('#team').append('<div class="member-next"></div>');
    $('#team').append('<div class="member-count"></div>');

    const htmlPersonLinks: string[] = [];
    $('#team')
      .find('.member-block')
      .each((i, item) => {
        const itemPersonName = $(item).find('.full-name');
        const textPersonName = itemPersonName[0]?.textContent?.trim() ?? '';

        const itemPersonPosition = $(item).find('.member-position');
        const textPersonPosition =
          itemPersonPosition[0]?.textContent?.trim() ?? '';

        const itemPersonPicture = $(item).find('.member-picture');
        const htmlPersonPicture = $(itemPersonPicture[0]).html();

        let htmlLink = '<a class="member-link" href="#team_header">';
        htmlLink += '<div class="link-wrapper">';
        htmlLink += `<div class="link-picture">${htmlPersonPicture}</div>`;
        htmlLink += '<div class="link-description">';
        htmlLink += `<div class="link-position">${textPersonPosition}</div>`;
        htmlLink += `<div class="link-name">${textPersonName}</div>`;
        htmlLink += '</div>';
        htmlLink += '</div>';
        htmlLink += '</a>';
        htmlPersonLinks.push(htmlLink);
      });

    let html = '<div class="member-others-wrapper">';
    html += '<div class="member-others">';
    html += htmlPersonLinks.join('');
    html += '</div>';
    html += '</div>';
    $('#team').append(html);

    const first_member_index = 0;
    this.switchTeamMember(first_member_index);
  }

  @on({ event: 'click', selector: '.member-link' })
  onClickMemberLink(event: JQuery.ClickEvent) {
    event.preventDefault();
    const href = $(event.currentTarget).attr('href');
    if (href == null) {
      return;
    }

    const target = $(href == '#' || href === '' ? 'html' : href);
    const offset = target.offset();
    if (offset == null) {
      return;
    }

    const addOffset = this.isMobile ? 40 : 0;
    const position = offset.top - addOffset;
    const miriSecMove = 500;
    $('html, body').animate({ scrollTop: position }, miriSecMove);

    const targetIndex = $(event.currentTarget).index('.member-link');

    setTimeout(() => {
      this.switchTeamMember(targetIndex);
    }, miriSecMove);
  }

  @on({ event: 'click', selector: '.member-prev' })
  onClickMemberPrev() {
    const itemBlocks = $('#team').find('.member-block');
    if (itemBlocks.length === 0) {
      return;
    }

    const itemActive = $('#team').find('.active');
    const currentIndex = $(itemBlocks).index($(itemActive));
    let targetIndex;
    if (currentIndex === 0) {
      targetIndex = itemBlocks.length - 1;
    } else {
      targetIndex = currentIndex - 1;
    }
    this.switchTeamMember(targetIndex);
  }

  @on({ event: 'click', selector: '.member-next' })
  onClickMemberNext() {
    const itemBlocks = $('#team').find('.member-block');
    if (itemBlocks.length === 0) {
      return;
    }

    const itemActive = $('#team').find('.active');
    const currentIndex = $(itemBlocks).index($(itemActive));
    let targetIndex;
    if (currentIndex === itemBlocks.length - 1) {
      targetIndex = 0;
    } else {
      targetIndex = currentIndex + 1;
    }
    this.switchTeamMember(targetIndex);
  }

  switchTeamMember(switchIndex: number) {
    const personCount = $('#team').find('.member-block').length;
    const personCountText = `${switchIndex + 1} of ${personCount}`;
    const itemPersonCount = $('#team').find('.member-count');
    $(itemPersonCount[0]).html(personCountText);

    $('#team')
      .find('.member-block')
      .each((i, item) => {
        if (i === switchIndex) {
          $(item).addClass('active').hide().fadeIn(0);
        } else {
          $(item).removeClass('active');
        }
      });

    $('#team')
      .find('.member-link')
      .each((i, item) => {
        if (i === switchIndex) {
          $(item).addClass('active');
        } else {
          $(item).removeClass('active');
        }
      });
  }

  renderMenter() {
    $('#menter').prop('data-turbo', false);
    $('#menter')
      .find('.menter-block')
      .each((i, item) => {
        const idName = `menter_${i + 1}`;
        $(item).attr('id', idName);
        if (i === 0) {
          $(item).addClass('active');
        }
      });

    // メンター一覧が2重に表示されるバグがあるので、一旦クリアする
    $('.menter-prev').remove();
    $('.menter-next').remove();
    $('.menter-count').remove();
    $('.menter-others-wrapper').remove();

    $('#menter').append('<div class="menter-prev"></div>');
    $('#menter').append('<div class="menter-next"></div>');
    $('#menter').append('<div class="menter-count"></div>');

    const htmlPersonLinks: string[] = [];
    $('#menter')
      .find('.menter-block')
      .each((i, item) => {
        const itemPersonName = $(item).find('.full-name');
        const textPersonName = itemPersonName[0]?.textContent?.trim();

        const itemPersonPosition = $(item).find('.menter-position');
        const textPersonPosition = itemPersonPosition[0]?.textContent?.trim();

        const itemPersonPicture = $(item).find('.menter-picture');
        const htmlPersonPicture = $(itemPersonPicture[0]).html();

        let htmlLink = '<a class="menter-link" href="#menter_header">';
        htmlLink += '<div class="link-wrapper">';
        htmlLink += `<div class="link-picture">${htmlPersonPicture}</div>`;
        htmlLink += '<div class="link-description">';
        htmlLink += `<div class="link-position">${textPersonPosition}</div>`;
        htmlLink += `<div class="link-name">${textPersonName}</div>`;
        htmlLink += '</div>';
        htmlLink += '</div>';
        htmlLink += '</a>';
        htmlPersonLinks.push(htmlLink);
      });

    let html = '<div class="menter-others-wrapper">';
    html += '<div class="menter-others">';
    html += htmlPersonLinks.join('');
    html += '</div>';
    html += '</div>';
    $('#menter').append(html);

    const first_menter_index = 0;
    this.switchMenter(first_menter_index);
  }

  @on({ event: 'click', selector: '.menter-link' })
  onClickMenterLink(event: JQuery.ClickEvent) {
    event.preventDefault();

    const href = $(event.currentTarget).attr('href');
    if (href == null) {
      return;
    }

    const target = $(href == '#' || href === '' ? 'html' : href);
    const offset = target.offset();
    if (offset == null) {
      return;
    }

    const addOffset = this.isMobile ? 40 : 0;
    const position = offset.top - addOffset;
    const miriSecMove = 500;
    $('html, body').animate({ scrollTop: position }, miriSecMove);

    const targetIndex = $(event.currentTarget).index('.menter-link');
    setTimeout(() => {
      this.switchMenter(targetIndex);
    }, miriSecMove);
  }

  @on({ event: 'click', selector: '.menter-prev' })
  onClickMenterPrev() {
    const itemBlocks = $('#menter').find('.menter-block');
    if (itemBlocks.length === 0) {
      return;
    }

    const itemActive = $('#menter').find('.active');
    const currentIndex = $(itemBlocks).index($(itemActive));
    let targetIndex;
    if (currentIndex === 0) {
      targetIndex = itemBlocks.length - 1;
    } else {
      targetIndex = currentIndex - 1;
    }
    this.switchMenter(targetIndex);
  }

  @on({ event: 'click', selector: '.menter-next' })
  onClickMenterNext() {
    const itemBlocks = $('#menter').find('.menter-block');
    if (itemBlocks.length === 0) {
      return;
    }

    const itemActive = $('#menter').find('.active');
    const currentIndex = $(itemBlocks).index($(itemActive));
    let targetIndex;
    if (currentIndex === itemBlocks.length - 1) {
      targetIndex = 0;
    } else {
      targetIndex = currentIndex + 1;
    }
    this.switchMenter(targetIndex);
  }

  switchMenter(switchIndex: number) {
    const personCount = $('#menter').find('.menter-block').length;
    const personCountText = `${switchIndex + 1} of ${personCount}`;
    const itemPersonCount = $('#menter').find('.menter-count');
    $(itemPersonCount[0]).html(personCountText);

    $('#menter')
      .find('.menter-block')
      .each((i, item) => {
        if (i === switchIndex) {
          $(item).addClass('active').hide().fadeIn(0);
        } else {
          $(item).removeClass('active');
        }
      });

    $('#menter')
      .find('.menter-link')
      .each((i, item) => {
        if (i === switchIndex) {
          $(item).addClass('active');
        } else {
          $(item).removeClass('active');
        }
      });
  }

  renderReadMore() {
    // 「続きを読む」ボタンをいったん全削除しないと2重表示されるバグがあるので対応した
    $('#description_body')
      .find('.read-more-triggar')
      .each((index, item) => {
        $(item).remove();
      });

    $('#detail_content')
      .find('.read-more-wrapper')
      .each((i, item) => {
        $(item).append(
          '<div class="read-more-triggar triggar-open">続きを読む</div>',
        );
      });

    $('#detail_content')
      .find('.read-more-body')
      .each((i, item) => {
        $(item).addClass('read-more-closed');
      });
  }

  @on({ event: 'click', selector: '.read-more-triggar' })
  onClickReadMoreTriggar(event: JQuery.ClickEvent) {
    if ($(event.currentTarget).hasClass('triggar-close')) {
      this.closeReadMore(event);
    } else {
      this.openReadMore(event);
    }
  }

  openReadMore(event: JQuery.ClickEvent) {
    const itemWrap = $(event.currentTarget).closest('.read-more-wrapper');
    $(itemWrap)
      .find('.read-more-body')
      .addClass('read-more-opened')
      .removeClass('read-more-closed');

    $(itemWrap)
      .find('.read-more-triggar')
      .removeClass('triggar-open')
      .addClass('triggar-close')
      .html('折りたたむ');
  }

  closeReadMore(event: JQuery.ClickEvent) {
    const itemWrap = $(event.currentTarget).closest('.read-more-wrapper');
    const offset = itemWrap.offset();
    if (offset == null) {
      return;
    }

    const addOffset = this.isMobile ? 115 : 40;
    const position = offset.top - addOffset;
    const miriSecScroll = 500;

    $('html, body').animate({ scrollTop: position }, miriSecScroll);

    setTimeout(() => {
      $(itemWrap)
        .find('.read-more-body')
        .addClass('read-more-closed')
        .removeClass('read-more-opened');

      $(itemWrap)
        .find('.read-more-triggar')
        .removeClass('triggar-close')
        .addClass('triggar-open')
        .html('続きを読む');
    }, miriSecScroll);
  }

  renderMileStone() {
    $('#detail_content')
      .find('.milestone-block:visible')
      .each((i, itemBlock) => {
        const itemBody = $(itemBlock).children('.milestone-body');
        const itemTitle = $(itemBlock).children('.milestone-title');
        const is_first_block = i == 0;
        if (is_first_block) {
          $(itemBody)
            .removeClass('milestone-closed')
            .addClass('milestone-opened');
          $(itemTitle).removeClass('triggar-open').addClass('triggar-close');
        } else {
          $(itemBody)
            .removeClass('milestone-opened')
            .addClass('milestone-closed');
          $(itemTitle).removeClass('triggar-close').addClass('triggar-open');
        }
      });
  }

  @on({ event: 'click', selector: '.milestone-title' })
  onClickMileStoneTitle(event: JQuery.ClickEvent) {
    if ($(event.currentTarget).hasClass('triggar-close')) {
      this.closeMileStoneBlock(event);
    } else {
      this.openMileStoneBlock(event);
    }
  }

  openMileStoneBlock(event: JQuery.ClickEvent) {
    const itemBlock = $(event.currentTarget).closest('.milestone-block');
    $(itemBlock)
      .find('.milestone-body')
      .removeClass('milestone-closed')
      .addClass('milestone-opened');

    $(itemBlock)
      .find('.milestone-title')
      .removeClass('triggar-open')
      .addClass('triggar-close');
  }

  closeMileStoneBlock(event: JQuery.ClickEvent) {
    const itemBlock = $(event.currentTarget).closest('.milestone-block');
    $(itemBlock)
      .find('.milestone-body')
      .removeClass('milestone-opened')
      .addClass('milestone-closed');

    $(itemBlock)
      .find('.milestone-title')
      .removeClass('triggar-close')
      .addClass('triggar-open');
  }

  @on({ event: 'click', selector: '.answer-open' })
  onClickAnswerOpen(event: JQuery.ClickEvent) {
    $(event.currentTarget).hide();
    $(event.currentTarget)
      .closest('.card-body-answer')
      .find('.answer-body')
      .removeClass('d-none');
  }

  loadFacebookSdk() {
    (function (d: Document, s: string, id: string) {
      if (d.getElementById(id)) {
        return;
      }
      const fjs = d.getElementsByTagName(s)[0] as HTMLElement;

      const js = d.createElement(s);
      js.id = id;
      js.setAttribute(
        'src',
        'https://connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v3.1',
      );
      fjs.parentNode?.insertBefore(js, fjs);
    })(document, 'footer', 'facebook-jssdk');
  }
}
